import { useState } from "react"

import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface UsePOFileUploadActionReturn {
  dialogOpen: boolean
  setDialogOpen: (show: boolean) => void
  canUpload: boolean
}

export const usePOFileUploadAction = (): UsePOFileUploadActionReturn => {
  const [dialogOpen, setDialogOpen] = useState(false)
  const { hasPermissions } = usePermissionManager()

  const canUpload = hasPermissions([PermissionActionType.PURCHASE_ORDER_CREATION])

  return {
    canUpload,
    dialogOpen,
    setDialogOpen,
  }
}
